import type { FundingProduct, User } from '@frontend/components/agromarket/core/access-control'
import type { IApplyingFinancingOfferRequestBody } from '@/logic/financing/interfaces'
import { EPriceUom } from '@/types'
import { normalizePhoneNumber } from '@/utils/formatUtils'
import { messages } from './messages'
import type { IMiniConsultingFormValues } from './types'

export const createRequestBody = (
  formValues: IMiniConsultingFormValues,
  productId: FundingProduct,
  user?: User,
): Partial<IApplyingFinancingOfferRequestBody> => ({
  productId,
  loanAmount: { value: 1, uom: EPriceUom.RUB },
  phone: normalizePhoneNumber(formValues.phone),
  comment: messages.financingProductsNames[formValues.productId as keyof typeof messages.financingProductsNames],
  organizationName: user?.organizationName,
  organizationInn: user?.organizationInn,
})
